import { defineComponent, openBlock, createElementBlock, normalizeClass, createBlock, createCommentVNode, createTextVNode, renderSlot } from 'vue';
import _sfc_main$1 from '../../atomes/Icons/IdfIcon.vue.mjs';
import '../../IdfTextIcon.vue_vue_type_style_index_0_scoped_1658f5f7_lang.css';
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "IdfTextIcon",
  props: {
    iconLeft: { default: "" },
    iconRight: { default: "" },
    hasIconCssColorVars: { type: Boolean, default: false },
    size: { default: "m" }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["idf-text-icon", `idf-text-icon--${__props.size}`])
      }, [
        __props.iconLeft ? (openBlock(), createBlock(_sfc_main$1, {
          key: 0,
          "has-css-color-vars": __props.hasIconCssColorVars,
          kind: __props.iconLeft,
          size: __props.size
        }, null, 8, ["has-css-color-vars", "kind", "size"])) : createCommentVNode("", true),
        _cache[0] || (_cache[0] = createTextVNode()),
        renderSlot(_ctx.$slots, "default", {}, void 0, true),
        _cache[1] || (_cache[1] = createTextVNode()),
        __props.iconRight ? (openBlock(), createBlock(_sfc_main$1, {
          key: 1,
          "has-css-color-vars": __props.hasIconCssColorVars,
          kind: __props.iconRight,
          size: __props.size
        }, null, 8, ["has-css-color-vars", "kind", "size"])) : createCommentVNode("", true)
      ], 2);
    };
  }
});

export { _sfc_main as default };
